import { get } from './';
export const getLocales = async () => get(`/languages`);
